export const BULK_UPLOAD_URL_PATHS = [ '/bulkupload', '/bulkupdate'];
